// extracted by mini-css-extract-plugin
export var hero = "resourcePost-module--hero--1zAz2";
export var imgContainer = "resourcePost-module--img-container--3i0uw";
export var bg = "resourcePost-module--bg--1eawC";
export var contentContainer = "resourcePost-module--content-container--3jaug";
export var description = "resourcePost-module--description--1s2PD";
export var pullUp = "resourcePost-module--pull-up--3-T5n";
export var formWrap = "resourcePost-module--form-wrap--2x8Y9";
export var heroImage = "resourcePost-module--hero-image--36ZZP";
export var heroImageSvg = "resourcePost-module--hero-image-svg--GeCDd";
export var bgSvg = "resourcePost-module--bg-svg--3b9TY";